import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Card, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import Cleave from "cleave.js/react";
import SelectDropDown from "../../shared/drop-down/drop-down";
import { AddOfficeToOrganization, UpdateOffice } from "../../../api";
const schema = yup.object({
    office_name: yup.string().trim().required("* Office name is required"),
});
class AddOfficeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedOffice ? true : false,
            is_submitted: false,
            formData: {
                office_name: props.selectedOffice
                    ? props.selectedOffice.name
                    : "",
                office_id: props.selectedOffice ? props.selectedOffice.id : "",
            },
            errors: [],
        };
        this.handleOfficeList = this.handleOfficeList.bind(this);
        this.updateChange = this.updateChange.bind(this);
    }

    handleOfficeList(evt) {
        let formData = this.state.formData;
        formData["stratus"] = true;
        const organization_id = this.props.organization_id;
        if (this.state.isEdit) {
            formData["id"] = this.props.selectedOffice.id;
            UpdateOffice(organization_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.props.addNewOffice(response.offices);
                    } else {
                        alert(response.message);
                    }
                })
                .catch((error) => console.log(error));
        } else {
            formData["stratus"] = true;
            AddOfficeToOrganization(organization_id, formData)
                .then((response) => {
                    if (response.success) {
                        this.props.addNewOffice(response.offices);
                    } else {
                        if (response.errors) {
                            let errorMessage = "";
                            Object.entries(response.errors).forEach(
                                ([key, value]) => {
                                    errorMessage =
                                        errorMessage === ""
                                            ? response.errors[key][0]
                                            : errorMessage +
                                              "\n" +
                                              response.errors[key][0];
                                },
                            );
                            alert(errorMessage);
                        } else {
                            alert(response.message);
                        }
                    }
                })
                .catch((error) => console.log(error));
        }
    }

    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = event.target.value.trim();
        this.setState({ formData: formData });
    }

    render() {
        const { is_submitted, formData, errors, isEdit } = this.state;
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual add-member-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit office" : "Add office"}
                    </h4>
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleOfficeList(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Office Name"
                                            type="text"
                                            name="office_name"
                                            value={values.office_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.office_name &&
                                                !!errors.office_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.office_name
                                            }
                                            className="preapp-form-input"
                                        />

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.office_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <div className="modal-footer">
                                    <button
                                        type="submit"
                                        className="btn confirm-button"
                                    >
                                        {isEdit ? "Update" : "Add"}
                                    </button>
                                    <button
                                        className="btn cancel-button"
                                        onClick={() => this.props.handleClose()}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ReactModal>
        );
    }
}

export default AddOfficeModal;
